import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import {
  fetchHoofdleidingGlobalsLists,
  initialState,
} from '../services/fetchHoofdleidingGlobalsLists'

export { useHoofdleidingGlobalsLists }

const useHoofdleidingGlobalsLists = () => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data } = useQuery({
    queryFn: fetchHoofdleidingGlobalsLists,
    queryKey: ['valuelists-hoofdleiding', 'globals'],
    enabled: hasPermissions,
  })

  return {
    data: data || initialState.data,
  }
}
